import {
  APP_SELECT_CITY_PATH,
  APP_SELECT_CITY_RETURN_URL_QUERY,
} from "@constants/appRoutes";

export function getAppSearchRedirectUrl(): string {
  return `${process.env.NEXT_PUBLIC_FRONTEND_HOST}/acko-app/search/`;
}

export function getAppSelectCityRedirectUrl(
  comingFromPathname?: string | null
): string {
  const base = `${process.env.NEXT_PUBLIC_FRONTEND_HOST}${APP_SELECT_CITY_PATH}`;
  const trimmed = comingFromPathname?.trim();
  if (!trimmed) {
    return base;
  }
  const params = new URLSearchParams();
  params.set(APP_SELECT_CITY_RETURN_URL_QUERY, trimmed);
  return `${base}?${params.toString()}`;
}
